import { Toast } from 'vant'
import ebizTrackUat from  './ebizTrackUat.es.js' // 测试环境sdk
import ebizTrackPrd from './ebizTrackPrd.es.js' // 生产环境sdk
// 此项目中，prd即生产环境，uat为测试环境
let ebizTrack = process.env.VUE_APP_FLAG == 'uat' ? ebizTrackUat : ebizTrackPrd
// import ebizTrackDev from './ebizTrack.es.js' // 测试环境sdk
// let ebizTrack = ebizTrackDev
/**
 * @desc  回溯数据组装及判断
 * @param  {String} orderNo 订单号
 * @param  {object} that 实例对象
 * @param  {String} routerName 节点名称
 * @param  {String} routerURL 页面全路径
 * @param  {boolean} productCode 产品编码
 * @param  {boolean} channelCode 渠道编码
 * @param  {boolean} isNew 是否生成新的sessionId
 * @param  {boolean} isDialog 是否弹框提示进入可回溯
 */
export function TrackStart(that, routerName, routerURL, orderNo, productCode, channelCode, isNew, isDialog) {
  let option = {
    routerName: routerName,
    routerURL: routerURL,
    isAutoRecord: true,
    isNew: isNew
  }
  let bussinessData = {
    channelCode: channelCode,
    businessCode: orderNo,
    productCode: productCode
  }
  if (isDialog) {
    that.$dialog({
      message: '您已进入投保流程，请您仔细阅读保险条款,您在投保页面的操作过程将被记录'
    })
  }
  return TrackInit(that, option, bussinessData)
}
export function TrackInit(that, option, bussinessData) {
  return new Promise(resolve => {
    ebizTrack
      .init(option, bussinessData)
      .then(res => {
        console.log(res, '可回溯开始了')
        that.trackState = true
        if (res.content.result == '0') {
          resolve(res.content)
        }
      })
      .catch(() => {
        Toast({
          message: '因可回溯平台出现系统异常，暂时无法进行后续操作，请您稍后再试'
        })
      })
  })
}
export function TrackStop(that,next) {
  return new Promise(resolve => {
    ebizTrack
      .stop()
      .then(res => {
        console.log('可回溯结束了')
        if (res.content.result == '0') {
          // Toast('录制结束')
          resolve('success')
        }
        if(next){
          next()
        }
        // next()
      })
      .catch(err => {
        console.log(err, 1)
        // TrackSave(that, pageCode, appntName, err.code, err.message)
        Toast({
          message: '因可回溯平台出现系统异常，暂时无法进行后续操作，请您稍后再试！'
        })
      })
  })
}

/**
 * @desc  手动可回溯埋点
 * @param  {object} that 实例对象
 * @param  {String} way 埋点方式 1--选择了
 * @param  {String} targetName 埋点key
 * @param  {boolean} value 埋点value
 */
export function TrackText(that, targetName, way, value) {
  let text
  switch (way) {
    case '1':
      text = ' 选择了 '
      break
    case '2':
      text = ' 点击了 '
      break
    case '3':
      text = ' 录入了 '
      break
    case '4':
      text = ' 通过ocr识别出了 '
      break
    case '5':
      text = ' 已勾选 '
      break
    case '6':
      text = ' 已取消勾选 '
      break
    case '7':
      text = ' 上传了 '
      break
    case '8':
      text = ' 删除了 '
      break
    case '9':
      text = ' 签字的名字是 '
      break
    case '10':
      text = ' 抄录的文字是 '
      break
  }
  console.log(targetName + text + value, 1)
  ebizTrack.manualText(targetName + text + value)
}

/**
 *
 * @param {*} that  上下文
 * @param {*} option 入参
 * @returns
 */
export function TrackComplete(that, option) {
  console.log(option, 'bu补充信息入参')
  return new Promise(resolve => {
    ebizTrack
      .createPolicy(option)
      .then(res => {
        if (res.content.result == '0') {
          // Toast('录制结束')
          resolve(res)
        }
      })
      .catch(() => {
        Toast({
          message: '因可回溯平台出现系统异常，暂时无法进行后续操作，请您稍后再试！！'
        })
      })
  })
}
/**
 *@desc  补充附件信息
 * @param {*} option 入参
 * @returns
 */
export function appendAnnexes(option) {
  console.log(option, 'option');
  ebizTrack.appendAnnexes(option)
}
/**
 * @desc  根据订单号查询回溯码

 * @param  {string} message 订单号
 */
export function sessionIdByOrder(message) {
  return new Promise(resolve => {
    ebizTrack.querySessionIdByOrder(message)
      .then(res => {
        if (res.content.result == '0') {
          // console.log(res, 'resz---------');
          // Toast('录制结束')

          resolve(res)
        }
      })
      .catch(() => {
        Toast({
          message: '因可回溯平台出现系统异常，暂时无法进行后续操作，请您稍后再试！！'
        })
      })
  })

}


/**
 * @desc  挂起回溯码
 * @param {*} that  上下文
 * @param  {object} sessionId 订单号
 */
export function hangUpSession(that, sessionId) {
  return new Promise(resolve => {
    ebizTrack.hangUpSession(sessionId)
      .then(res => {
        if (res.content.result == '0') {
          console.log(res, 'res----------');
          // Toast('录制结束')

          resolve(res)
        }
      })
      .catch(() => {
        Toast({
          message: '因可回溯平台出现系统异常，暂时无法进行后续操作，请您稍后再试！！'
        })
      })
  })

}
/**
 * @desc  唤起回溯码
 * @param {*} that  上下文
 * @param  {string} sessionId 回溯码
 */
export function notifySession(that, sessionId) {
  return new Promise(resolve => {
    ebizTrack.notifySession(sessionId)
      .then(res => {
        if (res.content.result == '0') {
          console.log(res, 'res----------');
          // Toast('录制结束')

          resolve(res)
        }
      })
      .catch(() => {
        Toast({
          message: '因可回溯平台出现系统异常，暂时无法进行后续操作，请您稍后再试！！'
        })
      })
  })

}

/**
 * @desc  截图
 * @param {*} that  上下文
 * @param  {object} option 截屏区域 (若采用默认值，请传null)
 */
export function ScreenShot(that, option) {
  let document = { screenShotElement: null };

  // ebizTrack.screenShot(document)
  return new Promise(resolve => {
    ebizTrack.screenShot(document).then(res => {
      console.log('截图了');
      // return res
      resolve(res)
    })
  })
};

